import { render } from "./RelatedFilesList.vue?vue&type=template&id=49e50461&scoped=true"
import script from "./RelatedFilesList.vue?vue&type=script&lang=js"
export * from "./RelatedFilesList.vue?vue&type=script&lang=js"

import "./RelatedFilesList.vue?vue&type=style&index=0&id=49e50461&lang=scss&scoped=true"
import "./RelatedFilesList.vue?vue&type=style&index=1&id=49e50461&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e50461"]])

export default __exports__